var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32 6.8933L11.5404 0.139951C11.6592 0.061623 11.7927 0.0147467 11.9305 0.00295455C12.0682 -0.00883763 12.2066 0.0147707 12.3348 0.0719505L12.4596 0.139951L22.68 6.8933C23.0529 7.13955 23.3668 7.48199 23.5954 7.89163C23.8239 8.30127 23.9602 8.76605 23.9928 9.24664L24 9.4733V19.668C24.0001 20.7748 23.6189 21.8398 22.9348 22.6443C22.2507 23.4488 21.3154 23.932 20.3208 23.9947L20.1 24H3.9C2.90384 24.0001 1.94541 23.5766 1.22132 22.8164C0.49724 22.0563 0.0623984 21.0171 0.00600014 19.912L0 19.6667V9.47064C0 8.48797 0.432 7.5733 1.1496 7.01463L1.32 6.8933L11.5404 0.141284L1.32 6.8933ZM22.2 10.5466L12.4164 16.22C12.3097 16.2818 12.1929 16.3192 12.0729 16.3299C11.953 16.3407 11.8323 16.3246 11.718 16.2826L11.5836 16.22L1.8 10.5466V19.6667C1.80002 20.2522 1.99821 20.8164 2.35522 21.2472C2.71223 21.6779 3.20196 21.9438 3.7272 21.992L3.9 22H20.1C20.6272 21.9999 21.1351 21.7796 21.5229 21.3826C21.9106 20.9856 22.1497 20.4412 22.1928 19.8573L22.2 19.6667V10.5466ZM12 2.16395L2.2896 8.5773L12 14.2053L21.708 8.57597L12 2.16262V2.16395Z",
    fill: "#004A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.80df788c.svg";
export { ForwardRef as ReactComponent };